import TrackedBill from './TrackedBill'
export default class LuPosition {
  constructor(objIn = {}) {
    const defaults = {
      //ID is required
      ID: 0,
      //Description is required
      Description: '',
      //IsActive is required
      IsActive: false,
    }
    let obj = {}
    Object.assign(obj, defaults, objIn)
    this.ID = obj.ID
    this.Description = obj.Description
    this.IsActive = obj.IsActive
    this.TrackedBills = []
    if (obj.TrackedBills) {
      obj.TrackedBills.forEach((item) => {
        this.TrackedBills.push(new TrackedBill(item))
      })
    }
  }
  removeRelated() {
    let obj = Object.assign({}, this)
    obj.TrackedBills = []
    if (this.TrackedBills) {
      this.TrackedBills.forEach((item) => {
        obj.TrackedBills.push(item.removeRelated())
      })
    }
    return obj
  }
  root() {
    let obj = Object.assign({}, this)
    obj.TrackedBills = null
    return obj
  }
}
